/**
 * One formatter for "when is this booking" (#106), shared by the customer
 * menu and the simulated notification so the two can never disagree.
 *
 * `bdt` is an instant (ISO string); the wall clock it means belongs to the
 * SALON's timezone, never the viewer's — the same rule the wizard's slots
 * follow (the #379 class of bugs).
 */
export function formatBookingWhen(bdt, salonTz, locale) {
  if (!bdt) return '';
  try {
    return new Intl.DateTimeFormat(locale || 'es', {
      timeZone: salonTz || undefined,
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(bdt));
  } catch {
    return String(bdt);
  }
}
